import React from 'react';

const DownloadsTab = ({ selected, downloads }) => {
  if (!downloads) {
    return null;
  }

  return (
    <div className={`tabbed-content-container${selected ? ' selected' : ''}`}>
      <h2>{downloads.title}</h2>
      <ul>
        {downloads.data.map((download, index) => (
          <li key={index}>
            <a href={download.file} target="_blank" rel="noreferrer">
              {download.description}
            </a>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default DownloadsTab;
